import {
  GetAllWarehousesRequestBuilder,
  GetWarehousesCountRequestBuilder,
  GetWarehousesInventoryRequestBuilder,
  UpdateWarehouseRequestBuilder,
  CreateWarehousesRequestBuilder,
  UpdateWarehouseStatusRequestBuilder,
  GetWarehousesChildrenRequestBuilder,
  GetWarehouseOperatorsRequestBuilder,
  UpdateWarehouseInventoryRequestBuilder,
  UpdateWarehouseInventoriesRequestBuilder,
  GetWarehouseInventoriesRequestBuilder,
  UpdateExcelWarehouseInventoriesRequestBuilder,
} from '../warehouses/warehouses';

import Client from '../client';
import {flattenObject} from '../helpers';
const token = localStorage.getItem('token') || '';

class WarehousesRepository {
  getWarehouses = async (actions: any) => {
    const makeRequest = new GetAllWarehousesRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetWarehousesCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };

  updateWarehouses = async (actions: any) => {
    const {body, pagination, id} = actions.payload;
    const makeUpdateRequest = new UpdateWarehouseRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return pagination;
  };
  createWarehouse = async (actions: any) => {
    const {body, pagination, id} = actions.payload;
    const makeRequest = new CreateWarehousesRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return {pagination, id};
  };
  getWarehousesInventory = async (actions: any) => {
    const {id, pagination} = actions.payload;
    const makeRequest = new GetWarehousesInventoryRequestBuilder()
      .params(flattenObject({...pagination, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getWarehouseInventory = async (actions: any) => {
    const {...actionsPayload} = actions.payload;
    const makeRequest = new GetWarehouseInventoriesRequestBuilder()
      .params(flattenObject({...actionsPayload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateWarehouseInventory = async (actions: any) => {
    const {body} = actions.payload;
    const makeUpdateRequest = new UpdateWarehouseInventoryRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return response;
  };
  updateWarehouseInventories = async (actions: any) => {
    const {body} = actions.payload;
    const makeUpdateRequest = new UpdateWarehouseInventoriesRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return response;
  };

  updateExcelWarehouseInventories = async (actions: any) => {
    const {body,partnerId} = actions.payload;
    const makeUpdateRequest = new UpdateExcelWarehouseInventoriesRequestBuilder()
      .data(body)
      .id(partnerId)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return response;
  };
  getWarehousesInventoryById = async (actions: any) => {
    const {id, pagination} = actions.payload;
    const makeRequest = new GetWarehousesInventoryRequestBuilder()
      .id(id)
      .params(flattenObject({...pagination, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getWarehouseOperatorsById = async (actions: any) => {
    const makeRequest = new GetWarehouseOperatorsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateWarehouseStatus = async (actions: any) => {
    const {id, body, pagination, callback} = actions.payload;
    const makeUpdateStatusRequest = new UpdateWarehouseStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateStatusRequest);
    return {pagination, callback};
  };
  getWarehouseWithId = async (actions: any) => {
    const makeRequest = new GetAllWarehousesRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getWarehouseChildren = async (actions: any) => {
    const {id, pagination} = actions.payload;
    const makeRequest = new GetWarehousesChildrenRequestBuilder()
      .id(id)
      .params(flattenObject({...pagination, sort: 'id,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateWarehouseAdmin = async (actions: any) => {
    const {body, pagination, id} = actions.payload;
    const makeUpdatRequest = new UpdateWarehouseRequestBuilder()
      .id(id)
      .data(body)
      .build();

    const client = new Client(token);
    await client.execute(makeUpdatRequest);
    return pagination;
  };
}

export default new WarehousesRepository();
